import AdvisorCard, { AdvisorCardProps } from '@components/Card/AdvisorCard/AdvisorCard';
import { FC } from 'react';
import styled from 'styled-components';
import CardGridWithPagination from '..';

export interface AdvisorCardGridProps {
  cardsPerPage: number;
  cardArr: AdvisorCardProps[];
}

const AdvisorCardGrid: FC<AdvisorCardGridProps> = ({ cardsPerPage, cardArr }) => {
  // map over cardArr and create array of AdvisorCard components
  const cardElements = cardArr.map((card, ind) => {
    return (
      <AdvisorCard
        key={ind}
        image={card.image}
        name={card.name}
        title={card.title}
        phone={card.phone}
        licenseNumber={card.licenseNumber}
        office={card.office}
        urlFacebook={card.urlFacebook}
        urlTwitter={card.urlTwitter}
        urlLinkedin={card.urlLinkedin}
        urlInstagram={card.urlInstagram}
        urlYoutube={card.urlYoutube}
        urlTiktok={card.urlTiktok}
        urlAdvisor={card.urlAdvisor}
        imageAspectRatio={card.imageAspectRatio}
      />
    );
  });
  return (
    <AdvisorCardGridContainer>
      <CardGridWithPagination
        cardsPerPage={cardsPerPage ? cardsPerPage : 18}
        cardArr={cardElements}
        testIdType="advisor-card"
        cardType="advisor"
      />
    </AdvisorCardGridContainer>
  );
};

export default AdvisorCardGrid;

const AdvisorCardGridContainer = styled.div``;
